// src/utils/format.js
// Tüm para ve sayı formatlama buradan yapılır

/**
 * Para formatı: 2500 → ₺2.500 veya ₺2.500,00
 * @param {number} amount
 * @param {boolean} showDecimal - kuruş göster (varsayılan: false)
 */
export const formatCurrency = (amount, showDecimal = false) => {
  if (amount === null || amount === undefined || isNaN(amount)) return '₺0';
  return '₺' + Number(amount).toLocaleString('tr-TR', {
    minimumFractionDigits: showDecimal ? 2 : 0,
    maximumFractionDigits: showDecimal ? 2 : 0,
  });
};

/**
 * Sayı formatı: 1234567 → 1.234.567
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '0';
  return Number(num).toLocaleString('tr-TR');
};